import React, { PropsWithChildren } from 'react';
import { Box, Stack, Typography } from '@mui/material';

interface Props extends PropsWithChildren {
  title: string;
}

export const ProductStack: React.FC<Props> = ({ title, children }) => {
  return (
    <Stack>
      <Box mb={4}>
        <Typography
          variant={'h4'}
          sx={{
            position: 'relative',
            marginBottom: '1.5rem',
            '&:after': {
              width: '45px!important',
              height: '1px!important',
              backgroundColor: 'secondary.dark',
              content: '""',
              position: 'absolute',
              margin: 'auto',
              bottom: '-10px',
              left: '0',
            },
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Stack>
  );
};
